export const documentTypes = {
    "project": [
        {
            name: "Alle",
            value: 0
        },
        {
            name: "DAILY_REPORT",
            value: 1
        },
        {
            name: "HOURLY_REPORT",
            value: 2
        },
        {
            name: "CORRESPONDENCE",
            value: 3
        },
        {
            name: "CONSTRUCTION_PLAN",
            value: 4
        },
        {
            name: "SUBMISSION_AMENDMENTS_RECEIPT",
            value: 5
        },
        {
            name: "PHOTO_DOCUMENTATION",
            value: 6
        },
        {
            name: "PROJECT_REPORT",
            value: 7
        },
        {
            name: "ESTIMATION",
            value: 8
        },
        {
            name: "MEASUREMENT",
            value: 9,
        },
        {
            name: "REQUIREMENT_FOR_ACCEPTANCE",
            value: 10,
            vob: true,
        },
        {
            name: "NOTICE_OF_DEFECTS",
            value: 11,
            vob: true,
        },
        {
            name: "NOTIFICATION_AND_REMEDY",
            value: 12,
            vob: true,
        },
        {
            name: "DISABILITY_DISPLAY",
            value: 13,
            vob: true,
        },
        {
            name: "PRICE_CHANGE_REQUEST",
            value: 14,
            vob: true,
        },
        {
            name: "CHANGE_DEADLINES_REQUEST",
            value: 15,
            vob: true,
        },
        {
            name: "REMINDER",
            value: 16,
            vob: true,
        },
        {
            name: "OFFER_ADDENDUM",
            value: 17,
            vob: true,
        },
        {
            name: "Other",
            value: 18,
            vob: true,
        },
    ],
    "client": [
        {
            name: "Alle",
            value: 0
        },
        {
            name: "OTHER",
            value: 1
        }
    ]
};
